/* eslint-disable import/no-cycle */
import { useFlutterBus } from '@/store/flutterBus';

export default class FromFlutterService {
  // This method is called when flutter app closes a file picker
  public static async closeImagePicker(pickerResultJsonString: string): Promise<void> {
    console.log('FromFlutterService.closeImagePicker(): Fired!');
    const pickerResultJsonObj = JSON.parse(pickerResultJsonString);

    // Pull all files
    const downloadedFiles: File[] = [];
    /* eslint-disable no-restricted-syntax */
    for (const pickerFile of pickerResultJsonObj.files) {
      /* eslint-disable no-await-in-loop */
      const downloadedFile: File = await FromFlutterService.downloadFileBase64FromFlutter(pickerFile.base64, pickerFile.name, pickerFile.mimeType);
      downloadedFiles.push(downloadedFile);
    }

    const flutterBus = useFlutterBus();
    flutterBus.flutterImagePickerFiles = null;
    flutterBus.flutterImagePickerFiles = downloadedFiles;
  }

  // This method is called when flutter app closes a file picker
  public static async closeFilePicker(pickerResultJsonString: string): Promise<void> {
    console.log('FromFlutterService.closeFilePicker(): Fired!');
    const pickerResultJsonObj = JSON.parse(pickerResultJsonString);

    // Pull all files
    const downloadedFiles: File[] = [];
    /* eslint-disable no-restricted-syntax */
    for (const pickerFile of pickerResultJsonObj.files) {
      /* eslint-disable no-await-in-loop */
      const downloadedFile: File = await FromFlutterService.downloadFileBase64FromFlutter(pickerFile.base64, pickerFile.name, pickerFile.mimeType);
      downloadedFiles.push(downloadedFile);
    }

    const flutterBus = useFlutterBus();
    flutterBus.flutterFilePickerFiles = null;
    flutterBus.flutterFilePickerFiles = downloadedFiles;
  }

  // This method is called when flutter app closes a camera
  public static async closeCamera(cameraResultJsonString: string): Promise<void> {
    console.log('FromFlutterService.closeCamera(): Fired!');
    const cameraResultJsonObj = JSON.parse(cameraResultJsonString);

    // Pull file
    const cameraFile = cameraResultJsonObj.file;
    const downloadedFile: File = await FromFlutterService.downloadFileBase64FromFlutter(cameraFile.base64, cameraFile.name, cameraFile.mimeType);
    const flutterBus = useFlutterBus();
    flutterBus.flutterCameraFile = null;
    flutterBus.flutterCameraFile = downloadedFile;
  }

  // A helper function that downloads a file from flutter's url
  private static async downloadFileBase64FromFlutter(base64: string, name: string, mimeType: string): Promise<File> {
    console.log('FromFlutterService.downloadFileFromFlutter(): name = ', name, ', mimeType =', mimeType);
    const response = await fetch(`data:${mimeType};base64,${base64}`);
    console.log('FromFlutterService.downloadFileFromFlutter(): Fetch response status =', response.status, ' type =', response.type, ' headers =', response.headers, ' name =', name, ' mimeType =', mimeType);
    const blob = await response.blob();
    console.log('FromFlutterService.downloadFileFromFlutter(): Fetch response blob.type =', blob.type);
    const options = { type: blob.type };
    return new File([blob], name, options);
  }
}
